<div class="incomming-call-box">
  <div class="message">
    <div class="text">Eingehender Anrufe von {{this.caller}}</div>
    <itl-flat-button (click)="this.handleAccept()"><mat-icon>call</mat-icon>Annehmen</itl-flat-button>
  </div>
</div>
